import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import { i18nMark, Trans } from 'lingui-react';

import { A, H2, P, QuickActionButton, Text } from 'base-components';
import { px2rem } from 'decisiv-ui-utils';
import { Row, Column } from 'styled-components-reactive-grid';

import Modal from 'components/Modal';

const lineBreaksRegex = /\r?\n/g;

export const valuesConfig = {
  driverAuthorized: {
    label: i18nMark('Driver Authorized'),
    mapValue: value => {
      // If it is undefined, then we have no preferences
      // data, so we return undefined to display the dash.
      if (value === undefined) {
        return undefined;
      }

      // Otherwise he have data and we can get a boolean or null
      return value ? i18nMark('Yes') : i18nMark('No');
    },
  },

  ersComments: { label: i18nMark('ERS Instructions') },
  tireDisposition: { label: i18nMark('Disposition of Off Tires') },
};

class ServicePreferenceValue extends Component {
  state = { showModal: false };

  toggleModal = () => this.setState({ showModal: !this.state.showModal });

  truncatedText = value => {
    if (!value) return '';

    if (value.length <= 300) {
      return <span>{value}</span>;
    }

    return (
      <Fragment>
        <span>{`${value.slice(0, 300)}... `}</span>
        <span>
          <A aria-label="read more" onClick={this.toggleModal}>
            <Trans>Read more</Trans>
          </A>
        </span>
      </Fragment>
    );
  };

  renderModal = (label, value) => (
    <Modal onClose={this.toggleModal}>
      {() => (
        <Modal.Body>
          <Modal.Header>
            <Modal.HeaderIcon name="info-circle" />
          </Modal.Header>
          <Modal.Content style={{ padding: `${px2rem(20)} 0 ${px2rem(4)} 0` }}>
            <Row modifiers={['center', 'padScaleY_5']}>
              <Column modifiers="padScaleY_0">
                <H2 modifiers="fontWeightRegular">
                  <Trans id={label} />
                </H2>
              </Column>
            </Row>
            <Row
              modifiers={['padScaleX_5']}
              style={{ overflowY: 'auto', maxHeight: px2rem(350) }}
            >
              <Column modifiers={['col', 'padScaleX_5']}>
                <P style={{ whiteSpace: 'pre-line' }}>{value}</P>
              </Column>
            </Row>
          </Modal.Content>
          <Modal.Footer>
            <Row modifiers="end">
              <Column>
                <QuickActionButton
                  type="button"
                  onClick={this.toggleModal}
                  modifiers="secondary"
                >
                  <QuickActionButton.Text>
                    <Trans>Close</Trans>
                  </QuickActionButton.Text>
                </QuickActionButton>
              </Column>
            </Row>
          </Modal.Footer>
        </Modal.Body>
      )}
    </Modal>
  );

  render() {
    const { label, type, values } = this.props;
    const { showModal } = this.state;

    const config = valuesConfig[type];
    const value = isString(values[type]) ? values[type].trim() : values[type];
    let mappedValue;

    if (type === 'ersComments') {
      if (lineBreaksRegex.test(value)) {
        mappedValue = (
          <A aria-label="show instructions" onClick={this.toggleModal}>
            <Trans>Show Instructions</Trans>
          </A>
        );
      }
    } else if (config.mapValue) {
      mappedValue = <Trans id={config.mapValue(value)} />;
    }

    return (
      <Fragment>
        <Text modifiers={['textLight']}>
          {mappedValue || this.truncatedText(value) || <span>&mdash;</span>}
        </Text>
        {showModal && this.renderModal(label, value)}
      </Fragment>
    );
  }
}

ServicePreferenceValue.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  values: PropTypes.shape({}).isRequired,
};

export default ServicePreferenceValue;



// WEBPACK FOOTER //
// ./src/compositions/CustomerWidget/CustomerDetails/ServicePreferences/ServicePreferenceValue.js